export default __webpack_public_path__ + "static/media/DSCN2278.11e5ec77.JPG";